import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  changeInquiryStatusAsync,
  deleteInquiryAsync,
  getMyInquiriesAsync,
} from "./actions";
import { IMyInquiriesState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<IMyInquiriesState>) => void;

export const getMyInquiriesReducer: Reducer = (builder) => {
  builder.addCase(getMyInquiriesAsync.pending, (state) => {
    state.myInquiries.isLoading = true;
  });

  builder.addCase(getMyInquiriesAsync.fulfilled, (state, actions) => {
    state.myInquiries.isLoading = false;
    state.myInquiries.data = actions.payload;
  });

  builder.addCase(getMyInquiriesAsync.rejected, (state) => {
    state.myInquiries.isLoading = false;
    state.myInquiries.data = null;
  });
};

export const deleteMyInquiriesReducer: Reducer = (builder) => {
  builder.addCase(deleteInquiryAsync.fulfilled, (state, actions) => {
    const deletedMyInquiryId = actions.payload;

    state.myInquiries.data.results = state.myInquiries.data.results.filter(
      ({ id }) => deletedMyInquiryId !== id
    );
  });
};

export const changeMyInquiryStatusReducer: Reducer = (builder) => {
  builder.addCase(changeInquiryStatusAsync.fulfilled, (state, actions) => {
    const { id: inquiryId, status } = actions.payload;

    const requiredInquiry = state.myInquiries.data.results.find(
      ({ id }) => inquiryId === id
    );
    requiredInquiry.status = status;
  });
};
